import { render, staticRenderFns } from "./AddChairMessage.vue?vue&type=template&id=a58a8eac&scoped=true&"
import script from "./AddChairMessage.vue?vue&type=script&lang=js&"
export * from "./AddChairMessage.vue?vue&type=script&lang=js&"
import style0 from "./AddChairMessage.vue?vue&type=style&index=0&id=a58a8eac&lang=scss&scoped=true&"
import style1 from "./AddChairMessage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58a8eac",
  null
  
)

export default component.exports